import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Case } from '../../../../core/models';
import { Observable } from 'rxjs';
import { CaseStatusCardComponent } from '../case-status-card/case-status-card.component';

@Component({
  selector: 'app-case-status-dialog',
  standalone: true,
  imports: [CommonModule, CaseStatusCardComponent],
  templateUrl: './case-status-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseStatusDialogComponent {
  @Input() caseDetails$!: Observable<Case | null>;

  // This will be provided by the service that opens the dialog
  close: () => void = () => { };
}
